import React from 'react';
import { lineStatus, LineStatus } from "../../util/varibles/constants";
import { ILiceInfo } from "../../util/varibles/interface";
import Icon, { ICON_NAME } from '../Icon';

const LiceStatus: React.FC<{ data?: { value?: number, state?: LineStatus } }> = ({ data }) => {
    const value = Math.round((data?.value || 0) * 100) / 100;
    const state = data?.state;
    const { color, css } = lineStatus[state || ""] || {};

    return <div className='flex items-center gap-[2px]'>
        {value}
        {state && <Icon icon={ICON_NAME.ARROW_RIGHT} size={12} style={css} bg={color} />}
    </div>
}

interface IProps {
    data?: ILiceInfo
}

const Lice: React.FC<IProps> = ({ data = {} }) => {
    const { total_lice, mobile_lice, female_lice, stationary_lice } = data;

    const total = Math.round((total_lice?.value || 0) * 100) / 100;

    return <div className='flex items-center'>
        {!!total && <>
            <span className='mr-1'>{total} </span>
            <span>(</span>
            <div className='flex items-center gap-1'>
                <div className='flex items-center'>
                    <LiceStatus data={stationary_lice} />,
                </div>
                <div className='flex items-center'>
                    <LiceStatus data={mobile_lice} />,
                </div>
                <LiceStatus data={female_lice} />
            </div>
            <span>)</span>
        </>}
    </div>
};

export default Lice;
